import { ref } from '@vue/reactivity';
import { showDialog } from 'vant';
import { showConfirmDialog } from 'vant';
import RouterUtil from '@/utils/RouterUtil';
import SessionUtil from '@/utils/SessionUtil';
import UserApi from '@/api/user-api';
import config from '../../../config';
export default {
  name: 'Login',
  computed: {
    config() {
      return config;
    }
  },
  setup() {
    const loginStep = ref('login-first');
    const loginButtonDisabled = ref(true);
    const doing = ref(false);
    const mobile = ref('');
    const captchaId = ref('');
    const captcha = ref('');
    const password = ref('');
    const agreementChecked = ref(false);
    const showKeyboard = ref(false);
    return {
      loginStep,
      loginButtonDisabled,
      doing,
      mobile,
      captcha,
      password,
      agreementChecked,
      showKeyboard
    };
  },
  mounted() {},
  watch: {
    captcha() {
      if (this.captcha.length === 6) {
        this.doLogin();
        this.showKeyboard = false;
      }
    }
  },
  methods: {
    mobileInputHandle() {
      if (this.mobile.length === 11) {
        this.loginButtonDisabled = !this.validatePhoneNumber(this.mobile);
      } else {
        this.loginButtonDisabled = true;
      }
    },
    passwordInputHandle() {
      if (this.password.length >= 6) {
        this.loginButtonDisabled = false;
      } else {
        this.loginButtonDisabled = true;
      }
    },
    validatePhoneNumber(str) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      return reg.test(str);
    },
    getCheckPhone() {
      const that = this;
      UserApi.getCheckPhone(that.mobile).then(function (result) {
        if (result.success) {
          // that.loginStep = "login-type-2";
          that.loginStep = 'login-type-1';
          that.getCaptcha();
        } else {
          that.loginStep = 'login-type-1';
          that.getCaptcha();
        }
      }).finally(function () {
        that.doing = false;
        that.loginButtonDisabled = true;
      });
    },
    getCaptcha() {
      const that = this;
      UserApi.getCaptcha(this.mobile).then(function (rs) {
        that.captchaId = rs.response.data.data;
      }).finally(function () {
        that.doing = false;
      });
    },
    doLogin() {
      const that = this;
      UserApi.login(this.mobile, this.captchaId, this.captcha).then(async function (rs) {
        if (rs.code === 200) {
          await UserApi.getUserInfo();
          RouterUtil.back();
          // setTimeout(function() {
          //   UserApi.getUserInfo();
          // }, 500);
        } else {
          showDialog({
            title: '登录失败',
            message: '[' + rs.code + '] ' + rs.msg
          });
        }
      }).catch(function () {
        showDialog({
          title: '登录失败',
          message: '登录请求出现异常，请重试'
        });
      }).finally(function () {
        that.doing = false;
      });
    },
    submitLogin() {
      const that = this;
      if (!this.agreementChecked) {
        showConfirmDialog({
          message: '在继续登录前，您需要阅读并同意《服务协议》和《个人信息处理规则》',
          confirmButtonText: '我已阅读并同意'
        }).then(() => {
          this.agreementChecked = true;
        }).catch(() => {
          // on cancel
        });
        return;
      }
      if (this.loginStep === 'login-first') {
        that.doing = true;
        //this.getCheckPhone();
        that.loginStep = 'login-type-1';
        this.getCaptcha();
      }
    }
  }
};